import './SidebarNav.css'
import SidebarNavLink from '../SidebarNavLink/SidebarNavLink';
import { IconHome, IconSchool, IconCertificate, IconHelpOctagon, IconMessage, IconTargetArrow, IconUser, IconBooks } from '@tabler/icons-react';
import { useContext } from 'react';
import AppContext from '../../../contexts/AppContext';

const SIDEBAR_NAVLINKS = [
   {
      id: 'home',
      text: 'Home',
      icon: < IconHome className='sidebar-navLink--icon' size={32} />,
      to: '/campus/dashboard'
   },
   {
      id: 'mis-cursos',
      text: 'Mis cursos',
      icon: < IconSchool className='sidebar-navLink--icon' size={32} />,
      to: '/campus/mis-cursos'
   },
   {
      id: 'mis-certificados',
      text: 'Mis Certificados',
      icon: < IconCertificate className='sidebar-navLink--icon' size={32} />,
      to: '/campus/certificaciones'
   },
   {
      id: 'biblioteca',
      text: 'Biblioteca',
      icon: < IconBooks className='sidebar-navLink--icon' size={32} />,
      to: '/campus/biblioteca'
   },
   {
      id: 'foro',
      text: 'Foro',
      icon: < IconMessage className='sidebar-navLink--icon' size={32} />,
      to: '/campus/foro',
      only_subscriptor: true
   },
   {
      id: 'oportunidades',
      text: 'Oportunidades',
      icon: < IconTargetArrow className='sidebar-navLink--icon' size={32} />,
      to: '/campus/oportunidades'
   },
   {
      id: 'mi-cuenta',
      text: 'Mi cuenta',
      icon: < IconUser className='sidebar-navLink--icon' size={32} />,
      to: '/campus/perfil'
   },
   {
      id: 'ayuda',
      text: 'Ayuda',
      icon: < IconHelpOctagon className='sidebar-navLink--icon' size={32} />,
      to: '/campus/ayuda'
   },
]

export default function SidebarNav() {

   const { currentUser } = useContext(AppContext)

   return (
      <nav className='sidebar-nav-container'>
         {SIDEBAR_NAVLINKS.map(item => {
            if(item.only_subscriptor && !currentUser?.subscription?.is_active){
                return null
            }
            return < SidebarNavLink key={item.id} id={item.id} text={item.text} icon={item.icon} to={item.to} />
         })}
      </nav>
   )
}
